import type { SVGProps } from "react";
export default function SvgEllipsisVertical(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-ellipsis-vertical-icon lucide-ellipsis-vertical"
			viewBox="0 0 24 24"
			{...props}
		>
			<circle cx={12} cy={12} r={1} />
			<circle cx={12} cy={5} r={1} />
			<circle cx={12} cy={19} r={1} />
		</svg>
	);
}
